{
  "PERSONAL_PROFILE": "Personal Profile",
  "FIRST_NAME": "First name",
  "LAST_NAME": "Last name",
  "EMAIL": "Email",

  "ACTIONS": {
    "SAVE": "Save",
    "CANCEL": "Cancel"
  },

  "PHOTO": {
    "TITLE": "Photo",
    "HINT": "Select a JPG, JPEG, or PNG file.",
    "UPLOAD_ERROR": "Error updating photo.",
    "UPLOAD_SUCCESS": "Successfully updated photo.",
    "ACTIONS": {
      "SAVE": "Save",
      "UPLOAD": "Upload",
      "UPLOAD_NEW": "Upload new photo",
      "REMOVE": "Remove photo",
      "UPLOAD_IMAGE": "Upload image",
      "CANCEL": "Cancel"
    },
    "REMOVE_MODAL": {
      "TITLE": "Remove image?",
      "CONTENT": "This can't be undone.",
      "REMOVE": "Remove",
      "KEEP": "Keep image"
    }
  },
  "EDIT_USER_PROFILE": {
    "INVALID_FORM": "Invalid form, please check all fields are filled in correctly",
    "COUNTRY_REQUIRED": "Country required, please select a country and try again",
    "SUCCESS": "User profile updated.",
    "FAILURE": "Error updating user.",
    "USER_NOT_FOUND": "Error getting your user profile."
  },
  "PHONES": {
    "ADD": "+Add phone number",
    "TITLE": "Phone number(s)"
  },
  "PASSWORD": {
    "TITLE": "Password",
    "CHANGE_PASSWORD": "Change password",
    "CURRENT_PASSWORD": "Current password",
    "NEW_PASSWORD": "New password",
    "INVALID_FORM": "Invalid form, please check all fields are filled in correctly",
    "CHANGE_ERROR": "Error changing password",
    "CHANGE_SUCCESS": "Successfully changed password"
  },
  "ADDRESS": {
    "TITLE": "Address"
  }
}
